import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DownloadSimple, CheckCircle, Export } from "@phosphor-icons/react";

// Buton „Instalează aplicația" cu un singur click (folosește evenimentul beforeinstallprompt
// capturat în index.html). Pe iOS afișează instrucțiunea Safari (nu există API de instalare).
export default function InstallButton({ className = "" }) {
  const [canInstall, setCanInstall] = useState(typeof window !== "undefined" && !!window.__deferredInstallPrompt);
  const [installed, setInstalled] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    try {
      const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
      setInstalled(!!standalone);
      setIos(/iphone|ipad|ipod/i.test(navigator.userAgent));
    } catch (e) { /* noop */ }
    const onProm = () => setCanInstall(true);
    const onInst = () => { setInstalled(true); setCanInstall(false); };
    window.addEventListener("pwa-installable", onProm);
    window.addEventListener("pwa-installed", onInst);
    return () => {
      window.removeEventListener("pwa-installable", onProm);
      window.removeEventListener("pwa-installed", onInst);
    };
  }, []);

  const doInstall = async () => {
    const e = window.__deferredInstallPrompt;
    if (!e) return;
    e.prompt();
    try { await e.userChoice; } catch (_) { /* noop */ }
    window.__deferredInstallPrompt = null;
    setCanInstall(false);
  };

  if (installed) {
    return (
      <span className={"inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-400 " + className} data-testid="install-app-installed">
        <CheckCircle size={18} weight="fill" /> Aplicația este instalată
      </span>
    );
  }
  if (ios) {
    return (
      <p className={"text-xs text-muted-foreground " + className} data-testid="install-app-ios">
        Pe iPhone/iPad deschide site-ul în <b className="text-foreground">Safari</b>, apasă{" "}
        <span className="inline-flex items-center gap-1 font-semibold text-foreground"><Export size={14} /> Partajează</span>{" "}
        → <b className="text-foreground">„Adaugă pe ecranul principal"</b>. Instalarea nu funcționează din Chrome pe iOS.
      </p>
    );
  }
  if (canInstall) {
    return (
      <Button onClick={doInstall} data-testid="install-app-btn" className={"gap-2 " + className}>
        <DownloadSimple size={18} weight="bold" /> Instalează aplicația
      </Button>
    );
  }
  return (
    <p className={"text-xs text-muted-foreground " + className} data-testid="install-app-hint">
      Dacă butonul de instalare nu apare imediat, navighează câteva secunde, apoi folosește meniul{" "}
      <b className="text-foreground">⋮</b> al browserului → <b className="text-foreground">„Instalează aplicația"</b>.
    </p>
  );
}
